import React from "react";

export default function PhotoCapture({
  fileInputRef,
  photoPreview,
  onPhotoSelected,
  onTakePhoto,
  onRetakePhoto,
  onUploadPhoto,
  photoUploading,
}) {
  return (
    <div className="bg-white rounded-2xl border border-gray-100 p-5 space-y-4 shadow-sm">
      <div className="text-center space-y-1">
        <h3 className="font-bold text-gray-900 text-base">
          Delivery Photo Proof
        </h3>
        <p className="text-xs text-gray-500">
          Take a photo showing the delivered parcel at drop-off location:
        </p>
      </div>

      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        capture="environment"
        onChange={onPhotoSelected}
        className="hidden"
      />

      {photoPreview ? (
        <div className="space-y-3">
          <div className="relative rounded-xl overflow-hidden border border-gray-200 aspect-video bg-gray-900">
            <img
              src={photoPreview}
              alt="Delivery proof"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="flex gap-2">
            <button
              onClick={onRetakePhoto}
              className="flex-1 py-2.5 rounded-xl border border-gray-200 text-gray-700 font-semibold text-xs hover:bg-gray-50"
            >
              Retake Photo
            </button>
            <button
              onClick={onUploadPhoto}
              disabled={photoUploading}
              className="flex-1 py-2.5 rounded-xl bg-green-600 text-white font-bold text-xs hover:bg-green-700 disabled:opacity-50"
            >
              {photoUploading ? "Uploading..." : "Confirm Photo"}
            </button>
          </div>
        </div>
      ) : (
        <button
          onClick={onTakePhoto}
          className="w-full py-8 border-2 border-dashed border-gray-300 rounded-xl flex flex-col items-center justify-center gap-2 hover:border-green-500 hover:bg-green-50/50 transition-colors"
        >
          <div className="w-12 h-12 bg-green-100 text-green-600 rounded-full flex items-center justify-center text-xl">
            📷
          </div>
          <p className="text-sm font-semibold text-gray-700">
            Tap to Take Photo
          </p>
        </button>
      )}
    </div>
  );
}
